import { mdiBriefcase, mdiDomain } from '@mdi/js'
import Icon from '@mdi/react'
import { useTranslation } from 'react-i18next'

import { AccordionItem, AccordionItemContent, AccordionItemTrigger, AccordionRoot } from '@/components/ui/accordion'
import { Box } from '@/components/ui/box'
import { Flex } from '@/components/ui/flex'
import { Text } from '@/components/ui/typography'
import useColorModeValue from '@/hooks/useColorModeValue'
import { IField } from '@/types/tasksApprovals'

import Comms from './comms'

const User = ({ item }: { item: IField }) => {
    const { t } = useTranslation()
    const iconColor = useColorModeValue('var(--chakra-colors-dark-700)', 'var(--chakra-colors-gray-500)')
    return item.userInfo?.email ? (
        <AccordionRoot multiple variant="gigiOutline" py="8px">
            <AccordionItem value={item.name}>
                <AccordionItemTrigger py="0" px="24px">
                    <Box as="span" flex="1" textAlign="left">
                        <Text fontSize="12px" pb="4px">
                            {item.name}
                        </Text>
                        <Text fontSize="14px" fontWeight="bold">
                            {item.value as string}
                        </Text>
                    </Box>
                </AccordionItemTrigger>

                <AccordionItemContent mt="16px" p="16px 24px 8px 24px">
                    <Flex flexDir="column" gap="10%">
                        <Flex flexDir="column">
                            <Flex flexDir="column">
                                <Box>
                                    <Text fontSize="14px" mb="8px">
                                        Contact info
                                    </Text>
                                </Box>
                                <Box display="flex">
                                    <Comms email={item.userInfo?.email} />
                                </Box>
                            </Flex>
                            <Box display="flex" mt="8px">
                                <Comms link={`https://teams.microsoft.com/l/chat/0/0?users=${item.userInfo?.email}`} />
                            </Box>
                        </Flex>

                        {item.userInfo?.manager && (
                            <Flex dir="column" mt="16px">
                                <Box>
                                    <Text fontSize="14px" mb="8px">
                                        {t('tasksApprovals.drawer.reportsTo')}
                                    </Text>
                                    <Comms email={item.userInfo?.manager.email} />
                                </Box>
                            </Flex>
                        )}
                    </Flex>
                    {(item.userInfo?.department || item.userInfo?.organisation) && (
                        <Flex gap="10%" mt="16px">
                            {item.userInfo?.department && (
                                <Flex flexDir="column" width="45%">
                                    <Text fontSize="14px" mb="16px">
                                        {t('tasksApprovals.drawer.department')}
                                    </Text>
                                    <Flex alignItems="center">
                                        <Icon path={mdiBriefcase} size={1} color={iconColor} style={{ marginRight: '8px' }} />
                                        <Text fontSize="14px">{item.userInfo?.department}</Text>
                                    </Flex>
                                </Flex>
                            )}
                            {item.userInfo?.organisation && (
                                <Flex flexDir="column" width="45%">
                                    <Text fontSize="14px" mb="16px">
                                        {t('tasksApprovals.drawer.organisation')}
                                    </Text>
                                    <Flex alignItems="center">
                                        <Icon path={mdiDomain} size={1} color={iconColor} style={{ marginRight: '8px' }} />
                                        <Text fontSize="14px">{item.userInfo?.organisation}</Text>
                                    </Flex>
                                </Flex>
                            )}
                        </Flex>
                    )}
                </AccordionItemContent>
            </AccordionItem>
        </AccordionRoot>
    ) : (
        <Box pb="16px" px="24px">
            <Text fontSize="12px" pb="4px">
                {item.name}
            </Text>
            <Text fontSize="14px" fontWeight="bold">
                {item.value as string}
            </Text>
        </Box>
    )
}

export default User
